import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { KeyRound, Loader2, LineChart } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const invite = params.get("invito") === "1";
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) return toast.error("La password deve avere almeno 6 caratteri");
    if (next !== confirm) return toast.error("Le due password non coincidono");
    setSaving(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: next });
      setDone(true);
      toast.success(invite ? "Account attivato. Ora puoi accedere." : "Password reimpostata. Ora puoi accedere.");
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-background p-4">
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm">
        <Card className="p-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="grid place-items-center h-9 w-9 rounded-lg bg-primary text-primary-foreground"><LineChart className="h-5 w-5" /></div>
            <div>
              <div className="font-heading font-bold">Bilancio CEE</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">XBRL Analyst Pro</div>
            </div>
          </div>
          <h2 className="font-heading text-xl font-bold flex items-center gap-2"><KeyRound className="h-5 w-5 text-primary" /> {invite ? "Attiva il tuo account" : "Reimposta Password"}</h2>
          {invite && token && !done && <p className="text-sm text-muted-foreground mt-2" data-testid="invite-intro">Benvenuto! Scegli la password per accedere al portale.</p>}
          {!token ? (
            <p className="text-sm text-red-500 mt-4">Link non valido o mancante. Richiedi un nuovo link di reset.</p>
          ) : done ? (
            <p className="text-sm text-emerald-500 mt-4">Password aggiornata! Reindirizzamento al login...</p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div className="space-y-2">
                <Label htmlFor="np">Nuova password</Label>
                <Input id="np" type="password" value={next} onChange={(e) => setNext(e.target.value)} data-testid="reset-new-input" autoComplete="new-password" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="cp">Conferma password</Label>
                <Input id="cp" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm-input" autoComplete="new-password" />
              </div>
              <Button type="submit" className="w-full" disabled={saving} data-testid="reset-submit-btn">
                {saving ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : null} {invite ? "Attiva account" : "Imposta nuova password"}
              </Button>
            </form>
          )}
        </Card>
      </motion.div>
    </div>
  );
}
